import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import MyPortfolioPage from './pages/PortfolioV2Page';
import RealtimePageV2 from './pages/RealtimePageV2';
import ArticlePage from './pages/ArticlePage';
import UserBox from './components/UserBox';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import toast, { Toaster } from 'react-hot-toast';
import { checkAllSignalUpdates, getUserInfo } from './composables/fetchAPI';
import { EMPTY_SIGNAL_SYNCS, getSignalSyncs } from './utils/signalSync';
import DashboardPage from './pages/DashboardPage';
import SearchBar from './components/SearchBar';
import ArticleDetailPage from './pages/ArticleDetailPage';
import CreateArticlePage from './pages/CreateUpdateArticlePage';
import ManagePortfolioPage from './pages/ManagePortfolioPage';
import AdminPortfolioPage from './pages/AdminPortfolioPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminRoute from './components/AdminRoute';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { UserProvider, useUser } from './context/UserContext';
import TelegramConnect from './pages/TelegramConnect';
import LoginAtTelegram from './pages/LoginAtTelegram';
import MoonIcon from './assets/icons/MoonIcon';
import SunIcon from './assets/icons/SunIcon';
import PortfolioDetailPage from './pages/PortfolioV2/PortfolioDetailPage'; // สร้างหน้าใหม่สำหรับรายละเอียดพอร์ต
import PortfolioRebuildPage from './pages/PortfolioV2/PortfolioRebuildPage'; // หน้าซ่อมพอร์ต (Rebuild)
import TelegramConnectPage from './pages/TelegramConnectPage';
import StockSearchBar from './components/StockSearchBar';
import { PortfolioProvider, usePortfolio } from './context/PortfolioContext';
import { MarketPriceProvider } from './context/MarketPriceContext';
import { NotificationProvider } from './context/NotificationContext';
import NotificationBell from './components/Notifications/NotificationBell';
import NotificationMobilePage from './pages/NotificationMobilePage';
import AdminNotificationsPage from './pages/Notifications/AdminNotificationsPage';
import PortfolioDashboardV2 from './pages/PortfolioV2/PortfolioDashboard';
import AdminShayPortfolioDetailPage from './pages/PortfolioV2/AdminShayPortfolioDetailPage'; // นำเข้าหน้าที่สร้างใหม่
import ReportIssueButton from './components/ReportIssueButton'; // แก้ไข Path ให้ตรงกับโฟลเดอร์ที่คุณเก็บไฟล์นี้ไว้
import { ImportJobProvider } from './context/ImportJobContext';
import ImportJobTracker from './components/PortfolioV2/ImportJobTracker';
import ScrollToTop from './composables/ScrollToTop';
import FAQPage from './pages/FAQPage';
import ResetLastSignalSyncPage from './pages/ResetLastSignalSyncPage';
import AssistantPage from './pages/AssistantPage';

const navStyle = 'fixed top-6 right-10 flex gap-4  rounded-lg px-6 py-3 shadow-lg z-50';
const navLink = 'text-gray-200 hover:text-yellow-400 transition-colors font-semibold text-lg px-2 pb-1';
const activeNavLink = 'border-b-4 border-yellow-400 text-yellow-400';

function App() {
  useEffect(() => {
    // Load theme from localStorage on app initialization
    const savedTheme = localStorage.getItem('theme') || 'dark'; // Default to dark theme
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);
  return (
    <Router>
      <ThemeProvider>
        <ImportJobProvider>
          <UserProvider>
            <NotificationProvider>
              <MarketPriceProvider>
                <PortfolioProvider>
                  <ScrollToTop />
                  <AppContent />
                </PortfolioProvider>
              </MarketPriceProvider>
            </NotificationProvider>
          </UserProvider>
        </ImportJobProvider>
      </ThemeProvider>
    </Router>
  );
}

function BugListPopup() {
  const bugs = [
    { id: 1, description: 'content Article สีขาวตอนเปลี่ยน Theme(Article)', progress: 100, done: true },
    { id: 2, description: 'เปลี่ยนหุ้นแล้วแต่จำนวนหุ้นและราคาไม่เปลี่ยน(Home)', progress: 100, done: true },
    { id: 3, description: 'SearchBar หาไม่ค่อยเจอ(Everywhere)', progress: 100, done: true },
    { id: 4, description: 'สัดส่วนของหุ้นไม่ตามพอร์ต(MyPortfolio)', progress: 100, done: true },
    { id: 5, description: 'ลิสต์ตรงหน้าพอร์ตของฉัน pieChart หุ้น ให้ชื่อหุ้นมันResponsiveลงมา(MyPortfolio)', progress: 100, done: true },
    { id: 6, description: 'กดRefresh แล้วมันควรอยู่หน้าหุ้นเดิมเช่นล่าสุดเปิด TSLA ก็ให้มันเป็นtsla(Home)', progress: 100, done: true },
    { id: 7, description: 'ตีเส้น "แนวรับ แนวต้าน" เรียบร้อย เมื่อกลับมาหุ้นนั้นอีกครั้ง เส้นที่ตีไว้หายหมด(Home)', progress: 100, done: true },
    { id: 8, description: 'ในหน้า "พอร์ตของฉัน" อยากให้กดเพิ่ม และให้มันบวกไปกับจำนวนหุ้นเดิมได้เลย ตอนนี้มัน error ว่าเคย เพิ่ม่หุ้นไปแล้ว(MyPortfolio)', progress: 100, done: true },
    { id: 9, description: '0.0xxxx ใส่จำนวนเงินแบบนี้ ลงไม่ได้เศษหุ้น เช่น 0.035 ไม่ได้(Everywhere)', progress: 100, done: true },
    { id: 10, description: 'ตอนเพิ่มหุ้น ให้มันsetSymbolเลยตั้งแต่พิมพ์ ticker(Everywhere)', progress: 100, done: true },
    { id: 11, description: 'Telegram Failed to verify Telegram (Telegram)', progress: 100, done: true },
    { id: 12, description: 'แก้ไขสัดส่วนเปอร์เซนต์หุ้น(Everywhere)', progress: 100, done: true },
    { id: 13, description: 'อัพเดตสัดส่วนพอร์ตแล้วไม่อัพเดตเรียลไทม์(Everywhere)', progress: 100, done: true },
    { id: 14, description: 'ทำกล่อง Progess ไว้ด้านบน อัพเดตความคืนหน้า(Everywhere)', progress: 100, done: true },
    { id: 15, description: 'หน้า Home กดเลือกหุ้นแล้วหน้าขาว(Home)', progress: 100, done: true },
    { id: 16, description: 'Resetวันใหม่ใน RealtimePageหลัง5โมง(ซื้อ-ขาย Realtime)', progress: 100, done: true },
    { id: 17, description: 'โหลด พอร์ตช้า หน้า home รวมถึง pie chart หน้า "พอร์ตของฉัน"', progress: 100, done: true },
    { id: 18, description: 'ตัวเลขค่าเงิน มีเครื่องหมาย คอมม่า ตามหลัก พัน-ล้าน ', progress: 100, done: true },
    { id: 19, description: 'กดตัวหุ้นในพอร์ตย่อยแล้วจะไปหน้ากระดานเทรด', progress: 100, done: true },
    { id: 20, description: 'พอร์ตย่อยกลายเป็น 0$', progress: 100, done: true },

    { id: 21, description: 'ทำปุ่มกำไรพิเศษ(MyPortfolio)', progress: 10, done: false },
  ];

  const sortedBugs = [...bugs].sort((a, b) => b.progress - a.progress);

  const getProgressColor = (progress: number) => {
    if (progress < 25) return 'bg-red-400';
    if (progress < 50) return 'bg-orange-400';
    if (progress < 81) return 'bg-yellow-400';
    return 'bg-green-500';
  };
  return (
    <div
      className="absolute bg-white shadow-lg rounded-lg p-4 mt-2 w-64 z-50"
      style={{
        maxHeight: '200px', // กำหนดความสูงสูงสุด
        overflowY: 'auto', // เพิ่ม scroll เมื่อเกินความสูง
      }}
    >
      <div className="text-black font-bold">
        Bug Report <span className="text-yellow-600">({bugs.length})</span>
      </div>
      <hr className="border-t border-gray-500 my-2" />
      <ul>
        {sortedBugs.map((bug, index) => (
          <React.Fragment key={bug.id}>
            <li className="mb-2">

              <div
                className={`text-sm font-medium ${bug.done ? 'text-gray-400 ' : 'text-gray-800'
                  }`}
              >
                {bug.done && (
                  <span className="text-green-500 mr-2">
                    ✓
                  </span>
                )}
                {bug.description} |{' '}
                <span
                  className={`${bug.done ? 'text-gray-400' : 'text-yellow-600'
                    }`}
                >
                  {bug.progress}%
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5 mt-1">
                <div
                  className={`h-2.5 rounded-full ${getProgressColor(bug.progress)}`}
                  style={{ width: `${bug.progress}%` }}
                ></div>
              </div>
            </li>
            {index < sortedBugs.length - 1 && <hr className="border-t border-gray-300 my-2" />}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
}
function AppContent() {
  const getInitialSymbol = () => {
    const params = new URLSearchParams(window.location.search);
    const symbolFromUrl = params.get('symbol');

    if (symbolFromUrl) {
      return symbolFromUrl.toUpperCase(); // ใช้จาก URL โดยตรง
    }

    // ถ้าไม่มี Param ถึงจะใช้ค่าที่แอดมินเคยเปิดทิ้งไว้ใน Tab หลัก
    return localStorage.getItem('selectedSymbol') || 'AAPL';
  };

  const [selectedSymbol, setSelectedSymbol] = useState(getInitialSymbol());
  // const [userInfo, setUserInfo] = useState<any>(null);
  const { userInfo, refreshUser } = useUser();
  const [showSearch, setShowSearch] = useState(false);
  const { toggleTheme } = useTheme(); // Use the theme toggle function
  const [isDarkTheme, setIsDarkTheme] = useState(true); // Track the current theme
  const [showPopup, setShowPopup] = useState(false);
  const [allHistoryDataForArticle, setAllHistoryDataForArticle] = useState<any[]>([]);
  const navigate = useNavigate();      // <-- Add this
  const location = useLocation();      // <-- Add this
  const { displayMode, setDisplayMode, toggleDisplayMode } = usePortfolio();  // เพิ่ม State สำหรับเช็ค Mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // ใน App.tsx
  const [signalData, setSignalData] = useState<any[]>([]);
  const [isSignalLoading, setIsSignalLoading] = useState(false);
  const { openTransactionModal, refreshUserPortfolios } = usePortfolio();
  // const {refreshUser} = useUser();
  // ✅ 2. ดักจับการเปลี่ยนแปลง URL (เผื่อแอดมินแก้ URL เองใน Tab เดิม)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const symbolFromUrl = params.get('symbol');

    if (symbolFromUrl && symbolFromUrl.toUpperCase() !== selectedSymbol) {
      setSelectedSymbol(symbolFromUrl.toUpperCase());
    }
  }, [location.search]);

  const handleFetchSignals = useCallback(async (isFull = false) => {
    setIsSignalLoading(true);
    try {
      // หุ้นกับคริปโตใช้ syncKey แยกกัน
      const data = await checkAllSignalUpdates(isFull ? EMPTY_SIGNAL_SYNCS : getSignalSyncs());

      if (data && data.signals) {
        const sortedNewData = [...data.signals].sort((a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );

        if (isFull) {
          setAllHistoryDataForArticle(sortedNewData);
        } else {
          setSignalData((prev) => {
            const signalMap = new Map(prev.map(s => [s.ticker, s]));
            data.signals.forEach((newSig: any) => signalMap.set(newSig.ticker, newSig));
            const merged = Array.from(signalMap.values()).sort((a: any, b: any) =>
              new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
            );
            setAllHistoryDataForArticle(merged);
            return merged;
          });
        }
      }
    } catch (err: any) {
      console.error(err.message);
    } finally {
      setIsSignalLoading(false);
    }
  }, []);


  // จัดการ Resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  const handleThemeToggle = () => {
    toggleTheme(); // Toggle theme
    setIsDarkTheme(prev => !prev); // Update local state
  };

  //   const fetchUser = async () => {
  //   try {
  //     // 1. ลองดึงจาก localStorage ก่อน
  //     const cachedUser = localStorage.getItem('userInfo');
  //     if (cachedUser) {
  //       setUserInfo(JSON.parse(cachedUser));
  //     }

  //     // 2. เรียก API เพื่อดึงข้อมูลล่าสุด (เสมอ) เพื่อความชัวร์ว่าข้อมูลไม่เก่า
  //     const info = await getUserInfo();

  //     // 3. อัปเดตทั้ง State และ localStorage
  //     setUserInfo(info);
  //     localStorage.setItem('userInfo', JSON.stringify(info));

  //   } catch (error: any) {
  //     setUserInfo(null);
  //     localStorage.removeItem('userInfo'); // ถ้าดึงพัง ให้ลบของเก่าทิ้ง

  //     setTimeout(() => {
  //       localStorage.removeItem('token');
  //       if (location.pathname !== '/login' && location.pathname !== '/telegram-connection') {
  //         navigate('/login');
  //       }
  //     }, 2000);
  //   }
  // };

  //  useEffect(() => {
  //   const isLoginPage = location.pathname === '/login' || location.pathname === '/telegram-connection' ;

  //   if (!isLoginPage) {
  //     // 1. เช็คว่ามีข้อมูลใน localStorage หรือไม่
  //     const cachedUser = localStorage.getItem('userInfo');

  //     // 2. ถ้ามีข้อมูลแล้ว ให้ใช้ set แล้วไม่ต้อง fetch หรือจะ fetch แบบ silent ก็ได้
  //     if (cachedUser) {
  //       setUserInfo(JSON.parse(cachedUser));
  //       // ถ้าไม่อยากยิง API เลย ให้ใส่ return ตรงนี้
  //       // แต่ถ้าอยากอัปเดตแบบเบาๆ ให้เรียกแบบไม่มี setLoading(true)
  //     } else {
  //       // 3. ถ้าไม่มีข้อมูลค่อย fetch
  //       fetchUser(); 
  //     }

  //     const interval = setInterval(() => {
  //       // ถ้าอยากให้ interval ยังทำงานเพื่ออัปเดตสถานะให้เป็นปัจจุบันเสมอ
  //       // ก็ปล่อยให้มันทำงานไป แต่ตัว fetchUser ข้างในต้องไปปรับให้เช็ค cache ด้วย
  //       fetchUser();
  //     }, 10000); 

  //     return () => clearInterval(interval);
  //   }
  // }, [location.pathname]);
  useEffect(() => {
    const isLoginPage = location.pathname === '/login' || location.pathname === '/telegram-connection';
    const isFaqPage = location.pathname === '/faq';
    const cachedUser = localStorage.getItem('userInfo');

    // ✅ ถ้าไม่ใช่หน้า Login และ (มี Token อยู่แล้ว หรือ ไม่ใช่หน้า FAQ) จึงจะดึงข้อมูล
    if (!isLoginPage && (cachedUser || !isFaqPage)) {
      // 1. เรียกใช้งานผ่าน Context (มันจะไปอ่าน cache ให้เองตามที่เขียนไว้)
      refreshUser();

      // 2. สั่งรันทุก 10 วินาที
      const interval = setInterval(() => {
        refreshUser(true);
      }, 10000);

      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  // แยก useEffect สำหรับบันทึก Symbol ออกมาต่างหาก
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.has('symbol')) {
      localStorage.setItem('selectedSymbol', selectedSymbol);
    }
  }, [selectedSymbol, location.search]);

  const handleSetSelectedSymbol = (newSymbol: string) => {
    const upperSymbol = newSymbol.toUpperCase();

    // ตรวจสอบว่าปัจจุบันมี Param ใน URL ไหม
    const params = new URLSearchParams(window.location.search);
    if (params.has('symbol')) {
      // ถ้ามี Param ให้เปลี่ยนหุ้นโดยการเปลี่ยน URL (เพื่อให้ Tab นั้นๆ ยังคงสถานะ URL-First)
      navigate(`/?symbol=${upperSymbol}`, { replace: true });
    } else {
      // ถ้าไม่มี Param (เช่น Tab หลัก) ให้เปลี่ยน State และบันทึก Storage ปกติ
      setSelectedSymbol(upperSymbol);
      localStorage.setItem('selectedSymbol', upperSymbol);
    }
  };

  // Function to handle login and store token
  const handleLogin = async (info: any) => {
    // บันทึก userInfo ลง localStorage ทันทีที่ Login สำเร็จ
    localStorage.setItem('userInfo', JSON.stringify(info));
    await refreshUser(true);
    await refreshUserPortfolios();

    // ถ้าถูกพามาหน้า Login เพราะเข้าหน้าที่ต้อง Login ก่อน (เช่น deeplink จาก push notification)
    // ให้กลับไปหน้านั้นแทนที่จะไปหน้า Home เสมอ
    // กรณี token หมดอายุ fetchAPI จะรีโหลดมาที่ /login?redirect=... (state หายไปแล้ว) เลยต้องอ่านจาก query ด้วย
    const from = (location.state as { from?: { pathname: string; search?: string } } | null)?.from;
    const redirectParam = new URLSearchParams(location.search).get('redirect');
    // รับเฉพาะ path ภายในเว็บ กัน open redirect (เช่น //evil.com) และกันวนกลับมาหน้า login
    const safeRedirect = redirectParam && redirectParam.startsWith('/') && !redirectParam.startsWith('//') && !redirectParam.startsWith('/login')
      ? redirectParam
      : null;
    const target = from ? `${from.pathname}${from.search || ''}` : (safeRedirect || '/');
    navigate(target, { replace: true });
  };
  // Hide navbar if on /login route
  const hideNavbar = location.pathname === '/login' || location.pathname === '/login/admin' || location.pathname === '/telegram-connection' || location.pathname === '/telegram-login';

  // ✅ เพิ่มตัวแปรนี้ เพื่อเช็คว่าเปิดหน้า FAQ โดยที่ยังไม่ได้ Login อยู่หรือเปล่า
  const isFaqGuest = location.pathname === '/faq' && !localStorage.getItem('userInfo');

  const handleClearSubportStorage = () => {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('selected_subport_')) {
        localStorage.removeItem(key);
      }
    });
  };
  return (
    <div className="relative h-screen flex flex-col" style={{ backgroundColor: 'var(--bg-color)', color: 'var(--text-color)' }}>
      {!hideNavbar && (
        <>
          <header className="flex-none z-50 sticky top-0" style={{
            backgroundColor: 'var(--bg-color)', // หรือใช้สีทึบ เช่น 'black' หรือ '#000000'
            backdropFilter: 'blur(10px)',
            borderBottom: '0.1px solid #374151' // เพิ่มเส้นขอบล่างเพื่อให้แบ่งชัดเจน
          }}>
            {/* Desktop & Mobile Header (Single Row) */}
            <div className="flex flex-row items-center justify-between w-full px-2 md:px-4 py-2 gap-2 md:gap-4 border-b border-gray-800 md:border-none"  >

              {/* ส่วนที่ 1: Logo + Name + On progress */}
              <div className="flex items-center gap-2 flex-shrink-0 cursor-pointer">
                <div className="flex items-center gap-2" onClick={() => navigate('/')}>
                  <img src="/piggy-usa.png" alt="Logo" className="w-7 h-7 md:w-10 md:h-10" />
                  <div>
                    <h1 className="text-sm md:text-base font-bold hidden sm:block" style={{ color: 'var(--text-color)' }}>
                      ลงทุนหุ้นอเมริกา
                    </h1>
                    <p className='text-[10px] ' style={{ color: 'var(--text-color)' }}>v1.10.4</p>
                  </div>

                </div>

                {/* <div className="relative">
                  <button
                    style={{ backgroundColor: 'var(--button-userbox)' }}
                    className="px-3 py-1.5 md:px-4 md:py-2 rounded-full text-[10px] md:text-sm font-bold bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white shadow-lg transform hover:scale-105 transition-transform"
                    onClick={() => setShowPopup((prev) => !prev)}
                  >
                    On progress...
                  </button>
                  {showPopup && <div className="absolute top-full mt-2 left-0 z-[60]"><BugListPopup /></div>}
                </div> */}
                <div className="relative">
                  {/* --- คอมเมนต์ปุ่มเดิมออก --- */}
                  {!userInfo?.isAdmin && (
                    <button
                      style={{ backgroundColor: 'var(--button-userbox)' }}
                      className="px-3 py-1.5 md:px-4 md:py-2 rounded-full text-[10px] md:text-sm font-bold bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white shadow-lg transform hover:scale-105 transition-transform"
                      onClick={() => window.open('https://youtu.be/ls1JsBQgb7I', '_blank')}
                    >
                      คู่มือการใช้เว็บ

                    </button>
                  )}

                  {/* --- ใส่ปุ่มใหม่เข้าไปแทนที่ --- */}
                  {/* 
                  {!userInfo?.isAdmin && (
                    <ReportIssueButton
                      jobId="..."
                      errorMessage="..."
                      className="!py-1.5 !px-3 md:!py-2 md:!px-4 !rounded-full"
                    />
                  )} */}
                  {showPopup && <div className="absolute top-full mt-2 left-0 z-[60]"><BugListPopup /></div>}
                </div>
              </div>

              {/* ส่วนที่ 2: NavBar (แสดงเฉพาะ Desktop บรรทัดเดียวกับโลโก้) */}
              {/* ส่วนที่ 2: NavBar */}
              {isFaqGuest ? (
                // ✅ ถ้าเข้า FAQ จากหน้า Login จะโชว์แค่ปุ่มกลับ
                <nav className="flex items-center gap-1 overflow-x-auto no-scrollbar flex-1 justify-end md:justify-center px-4">
                  <button
                    onClick={() => navigate('/login')}
                    className="px-4 py-2 rounded-full bg-yellow-400 text-black font-bold text-xs md:text-sm shadow-md hover:bg-yellow-300 transition-all flex items-center gap-2"
                  >
                    <span>←</span> กลับไปยังหน้า Login
                  </button>
                </nav>
              ) : (
                // ❌ ถ้าเป็นสมาชิกที่ล็อกอินแล้ว หรือหน้าอื่นๆ จะแสดง NavBar ปกติ
                !isMobile && (
                <nav className="flex items-end gap-1 overflow-x-auto no-scrollbar flex-1 justify-center px-4">
                  <NavLink to="/" end className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}>
                    <span className="text-xs whitespace-nowrap" style={{ color: 'var(--text-color)' }}>กระดานเทรด</span>
                  </NavLink>
                  <NavLink to="/portfolio" className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}
                    onClick={handleClearSubportStorage} // ✅ เคลียร์ค่าเมื่อคลิก
                  >
                    <span className="text-xs whitespace-nowrap" style={{ color: 'var(--text-color)' }}>พอร์ตของฉัน</span>
                  </NavLink>
                  <NavLink to="/assistant" className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}>
                    <span className="text-xs whitespace-nowrap" style={{ color: 'var(--text-color)' }}>ผู้ช่วย</span>
                  </NavLink>
                  {/* ไม่ใช้ isActive ของ NavLink เพราะ "/admin" เป็น prefix ของ "/admin/notifications" ด้วย (ทำให้ underline ผิดหน้า)
                      เช็คเองแทน: active เฉพาะ "/admin" หรือ "/admin/:id" (หน้ารายละเอียดพอร์ต) แต่ไม่รวม "/admin/notifications" */}
                  <NavLink to="/admin" className={
                    (location.pathname === '/admin' || (location.pathname.startsWith('/admin/') && !location.pathname.startsWith('/admin/notifications')))
                      ? `${navLink} ${activeNavLink}` : navLink
                  }
                    onClick={handleClearSubportStorage} // ✅ เคลียร์ค่าเมื่อคลิก
                  >
                    <span className="text-xs whitespace-nowrap" style={{ color: 'var(--text-color)' }}>ดูพอร์ตแอดมิน</span>
                  </NavLink>
                  <NavLink to="/realtime" className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}>
                    <span className="text-xs whitespace-nowrap" style={{ color: 'var(--text-color)' }}>มุมมอง ซื้อ-ขาย</span>
                  </NavLink>
                  <NavLink to="/articles" className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}>
                    <span className="text-xs whitespace-nowrap" style={{ color: 'var(--text-color)' }}>บทความ</span>
                  </NavLink>
                  <NavLink to="/faq" className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}>
                    <span className="text-xs whitespace-nowrap" style={{ color: 'var(--text-color)' }}>ช่วยเหลือ</span>
                  </NavLink>
                  {userInfo?.isAdmin && (
                    <NavLink to="/dashboard" className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}>
                      <span className="text-xs whitespace-nowrap nav-admin-glow-text">Dashboard</span>
                    </NavLink>
                  )}
                  {userInfo?.isAdmin && (
                    <NavLink to="/admin/notifications" className={({ isActive }) => isActive ? `${navLink} ${activeNavLink}` : navLink}>
                      <span className="text-xs whitespace-nowrap nav-admin-glow-text">จัดการแจ้งเตือน</span>
                    </NavLink>
                  )}
                </nav>
              )
              )}

              {/* ส่วนที่ 3: Search, UserBox, Theme */}
              {!isFaqGuest && (
                <div className="flex items-center gap-1 md:gap-3 flex-shrink-0">

                {location.pathname === '/' && (
                  <div className="relative flex items-center">

                    {/* 1. SearchBar สำหรับ Desktop (โชว์ตลอดเวลา) */}
                    <div className="hidden md:block w-[230px] lg:w-[260px] mr-2">
                      <SearchBar includeCrypto compactToggle onSelect={symbol => { setSelectedSymbol(symbol); }} />
                    </div>

                    {/* 2. SearchBar สำหรับ Mobile (ทำงานเมื่อ showSearch เป็น true) */}
                    {showSearch && (
                      <div className="fixed left-0 top-[60px] w-full px-4 z-[60] mt-2 md:hidden">
                        <div className="bg-[var(--component-bg-color)] p-2 rounded-xl shadow-2xl border border-gray-700">
                          <SearchBar includeCrypto onSelect={symbol => { setSelectedSymbol(symbol); setShowSearch(false); }} />
                        </div>
                      </div>
                    )}

                    {/* 3. ปุ่มแว่นขยาย (แสดงเฉพาะบน Mobile) */}
                    <button
                      className="p-1.5 md:p-2 rounded-full shadow-lg bg-[var(--component-bg-color)] active:scale-90 transition-transform md:hidden"
                      onClick={() => setShowSearch(prev => !prev)}
                    >
                      <MagnifierIcon className="w-5 h-5 text-yellow-400" />
                    </button>

                  </div>
                )}

                {/* ✅ เพิ่มปุ่ม S/B (Sell/Buy) ตรงนี้ */}
                {displayMode === 'V2' && (
                  // <button
                  //   onClick={() => openTransactionModal({})}
                  //   className="flex items-center justify-center bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 text-[#18181b] font-black text-xs md:text-sm px-3 py-1.5 md:px-4 md:py-2 rounded-lg shadow-md transition-transform active:scale-95"
                  // >
                  //   S/B
                  // </button>
                  <img src="/icons/shopping-cart.png"
                    onClick={() => openTransactionModal({})}
                    alt="ซื้อ-ขายหุ้น" className="w-8 h-8 mr-2 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 rounded-lg px-1 py-0.5" />

                )}

                {/* {!isMobile && (
                  <div className="flex items-center gap-2 bg-gray-800 p-1 rounded-lg">
                    <button
                      onClick={() => {
                        toggleDisplayMode('V1');
                      }}
                      className={`px-2 py-1 rounded-md text-xs font-bold transition-all ${displayMode === 'V1' ? 'bg-yellow-500 text-black' : 'text-gray-400'}`}
                    >
                      โหมดง่าย
                    </button>
                    <button
                      onClick={() => {
                        toggleDisplayMode('V2');
                      }}
                      className={`px-2 py-1 rounded-md text-xs font-bold transition-all ${displayMode === 'V2' ? 'bg-yellow-500 text-black' : 'text-gray-400'}`}
                    >
                      โหมดแม่นยำ
                    </button>
                  </div>
                )} */}
                {!isMobile && (
                  <div className='border border-stone-500 p-1 rounded-lg flex flex-row items-center shadow-lg bg-[#1e1e1e]'>
                    <div className='text-sm font-bold mr-2 ml-1 text-white'>โหมด:</div>

                    <button
                      onClick={() => {
                        toggleDisplayMode(displayMode === 'V1' ? 'V2' : 'V1');
                      }}
                      // ไฮไลท์การแก้ไข: ใส่ w-[76px], flex, justify-center และ whitespace-nowrap
                      className={`w-[56px] flex items-center justify-center py-1.5 rounded-md text-sm font-bold whitespace-nowrap transition-all duration-300 shadow-md ${displayMode === 'V1'
                          ? 'bg-green-500 text-white hover:bg-green-600'
                          : 'bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 hover:from-yellow-500 hover:to-orange-600'
                        }`}
                    >
                      {displayMode === 'V1' ? 'ง่าย' : 'แม่นยำ'}
                    </button>
                  </div>
                )}


                {/* มือถือ: กระดิ่งย้ายไปอยู่ขวาของ UserBox แทน / จอใหญ่: อยู่ซ้าย UserBox ตามเดิม */}
                <NotificationBell className="order-2 " />

                <div className="order-1 md:order-none">
                <UserBox
                  user={userInfo}
                  displayMode={displayMode}
                  setDisplayMode={(mode: string) => {
                    // ตรวจสอบก่อนเรียกใช้ เพื่อความปลอดภัย
                    if (mode === "V1" || mode === "V2") {
                      toggleDisplayMode(mode);
                    }
                  }}
                />
                </div>

                {/* <button className="rounded-full bg-white shadow p-1.5 md:p-2 flex items-center justify-center" onClick={handleThemeToggle}>
                  {!isDarkTheme ? <SunIcon size={isMobile ? 14 : 16} /> : <MoonIcon size={isMobile ? 14 : 16} />}
                </button> */}
              </div>
              )}
            </div>
          </header>

          {/* Bottom Navigation สำหรับ Mobile - กลับมาแล้ว! */}
          {isMobile && !isFaqGuest && (
            <nav className="fixed bottom-0 left-0 right-0 z-[100] flex justify-around items-center py-4 shadow-[0_-4px_12px_rgba(0,0,0,0.4)] border-t border-gray-700"
              style={{
                backgroundColor: 'var(--bg-navbar)',
                backdropFilter: 'blur(10px)',
                height: '70px' // กำหนดความสูงคงที่เพื่อให้ดูเต็มตาขึ้น
              }}>
              <NavLink to="/" end className={({ isActive }) => `flex flex-col items-center gap-1 ${isActive ? 'text-yellow-400 font-black' : 'text-gray-400'}`}>
                <span className="text-[14px] md:text-base">หน้าหลัก</span> {/* ขยายตัวอักษร */}
              </NavLink>
              <NavLink to="/portfolio" className={({ isActive }) => `flex flex-col items-center gap-1 ${isActive ? 'text-yellow-400 font-black' : 'text-gray-400'}`}
                onClick={handleClearSubportStorage} // ✅ เคลียร์ค่าเมื่อคลิก
              >
                <span className="text-[14px] md:text-base">พอร์ต</span>
              </NavLink>
              <NavLink to="/assistant" className={({ isActive }) => `flex flex-col items-center gap-1 ${isActive ? 'text-yellow-400 font-black' : 'text-gray-400'}`}>
                <span className="text-[14px] md:text-base">ผู้ช่วย</span>
              </NavLink>
              <NavLink to="/admin" className={({ isActive }) => `flex flex-col items-center gap-1 ${isActive ? 'text-yellow-400 font-black' : 'text-gray-400'}`}
                onClick={handleClearSubportStorage} // ✅ เคลียร์ค่าเมื่อคลิก
              >
                <span className="text-[14px] md:text-base">แอดมิน</span>
              </NavLink>
              <NavLink to="/realtime" className={({ isActive }) => `flex flex-col items-center gap-1 ${isActive ? 'text-yellow-400 font-black' : 'text-gray-400'}`}>
                <span className="text-[14px] md:text-base">มุมมอง</span>
              </NavLink>
              <NavLink to="/articles" className={({ isActive }) => `flex flex-col items-center gap-1 ${isActive ? 'text-yellow-400 font-black' : 'text-gray-400'}`}>
                <span className="text-[14px] md:text-base">บทความ</span>
              </NavLink>
            </nav>
          )}
        </>
      )}


      <ImportJobTracker />


      {/* Main เนื้อหา - ใช้ pb-20 เฉพาะ Mobile เพื่อหลบ Bottom Tab */}
<main className={`flex-1 overflow-y-auto ${isMobile && !hideNavbar && !isFaqGuest ? 'pb-20' : ''}`}>      
    <div className="w-full mx-auto">
          <Routes>
            <Route path="/telegram-connection" element={<TelegramConnectPage />} />
            <Route path="/telegram-login" element={<LoginAtTelegram />} />
            <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
            <Route path="/login/admin" element={<AdminLoginPage onLogin={handleLogin} />} />
            <Route path="/faq" element={<FAQPage userInfo={userInfo} />} />
            <Route path="/reset-last-signal-sync-time" element={<ResetLastSignalSyncPage />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <Routes key={location.pathname}>
                  <Route path="/" element={<HomePage selectedSymbol={selectedSymbol} setSelectedSymbol={setSelectedSymbol} userInfo={userInfo} setAllHistoryDataForArticle={setAllHistoryDataForArticle} />} />
                  <Route path="/portfolio/:id" element={<PortfolioDetailPage selectedSymbol={selectedSymbol} setSelectedSymbol={setSelectedSymbol} />} />
                  <Route path="/portfolio/:id/rebuild" element={<PortfolioRebuildPage />} />
                  <Route path="/admin/:id" element={<PortfolioDetailPage selectedSymbol={selectedSymbol} setSelectedSymbol={setSelectedSymbol} />} />
                  <Route path="/portfolio" element={<PortfolioDashboardV2 />} />
                  <Route path="/admin" element={<PortfolioDashboardV2 />} />
                  <Route path="/admin-Shay/:id" element={<AdminShayPortfolioDetailPage />} />
                  <Route path="/realtime" element={<RealtimePageV2 userInfo={userInfo} />} />
                  <Route path="/articles" element={<ArticlePage userInfo={userInfo} />} />
                  <Route path="/dashboard" element={<AdminRoute userInfo={userInfo}><DashboardPage /></AdminRoute>} />
                  <Route path="/admin/notifications" element={<AdminRoute userInfo={userInfo}><AdminNotificationsPage /></AdminRoute>} />
                  <Route path="/notifications" element={<NotificationMobilePage />} />
                  <Route path="/article/:id" element={<ArticleDetailPage onRefresh={handleFetchSignals} allHistoryDataForArticle={allHistoryDataForArticle} />} />
                  <Route path="/articles/create" element={<AdminRoute userInfo={userInfo}><CreateArticlePage /></AdminRoute>} />
                  <Route path="/create-article/:articleId" element={<AdminRoute userInfo={userInfo}><CreateArticlePage /></AdminRoute>} />
                  <Route path="/manage-portfolio" element={<ManagePortfolioPage userInfo={userInfo} />} />
                  <Route path="/assistant" element={<AssistantPage userInfo={userInfo} />} />
                  <Route path="/privacy" element={<PrivacyPolicyPage />} />
                  <Route path="*" element={<NotFoundPage />} />

                </Routes>
              </ProtectedRoute>
            } />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </main>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
    </div>
  );
}

function MagnifierIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="11" cy="11" r="8" strokeWidth="2" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" strokeWidth="2" />
    </svg>
  );
}

export default App;
